const FingerprintJS = require('@fingerprintjs/fingerprintjs');
(async () => {
    // We recommend to call `load` at application startup.
    const fp = await FingerprintJS.load();

    // The FingerprintJS agent is ready.
    // Get a visitor identifier when you'd like to.
    const result = await fp.get();

    // This is the visitor identifier:
    const visitorId = result.visitorId;
    if (window.livewire) {
        window.livewire.emit('setFingerprint', visitorId);
    }
})();